import MulliganSite from "../assets/images/mulligan-site.png"

const mulligan_site = {
    slug: "Mulligan_TCG_Site_Web",
    sections: [
        {
            elements: [
                { type: "title-prc", content: "Mulligan - Site web TCG" },
                { type: "tex-prc", content: "Développement web collaboratif pour une communauté de jeux de cartes à collectionner en Normandie. Projet académique Ynov Campus." },
                { type: "imageTitle", src: MulliganSite, alt: "Site web Mulligan en cours de développement" }
            ]
        },
        {
            elements: [
                { type: "title", content: "Présentation du projet" },
                { type: "text", content: "Mulligan est un projet académique développé dans le cadre des Ydays à Ynov Campus Rouen. L'objectif est de créer une plateforme dédiée au Trading Card Game (TCG - jeux de cartes à collectionner) en Normandie, visant à fédérer une communauté de joueurs passionnés autour d'événements, d'échanges et de tournois." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Travail collaboratif pluridisciplinaire" },
                { type: "text", content: "Ce projet se distingue par sa dimension collaborative enrichissante. Je travaille aux côtés d'étudiants M1 en graphisme d'Ynov, chacun apportant son expertise spécifique. L'équipe réunit des compétences variées : design graphique, développement web, audiovisuel et communication. Cette diversité de profils permet de créer une identité de marque complète et cohérente." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Création de l'identité Mulligan" },
                { type: "text", content: "Ensemble, nous construisons l'identité visuelle et stratégique de Mulligan. L'objectif est de positionner la marque comme une référence du TCG en Normandie. Nous travaillons sur le logo, la charte graphique, le ton de communication et l'ensemble des éléments qui donneront vie à cette communauté." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Mon rôle : le développement web" },
                { type: "text", content: "Ma responsabilité se concentre sur le développement technique du site web. Je prends en charge l'analyse des besoins fonctionnels, l'architecture de l'application et l'implémentation des fonctionnalités. Je travaille en étroite collaboration avec l'équipe design pour transformer les maquettes graphiques en interfaces web performantes et responsive." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Fonctionnalités du site" },
                { type: "text", content: "Le site Mulligan proposera plusieurs fonctionnalités clés : présentation de la communauté et de ses valeurs, calendrier des événements et tournois, système d'inscription aux événements, espace d'échange entre joueurs, et actualités du monde du TCG en Normandie. L'objectif est de créer un véritable hub pour les passionnés." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Projet en cours de développement" },
                { type: "text", content: "Mulligan est actuellement en phase de développement actif. Les fonctionnalités sont progressivement implémentées et testées. Le site n'est pas encore disponible en ligne publiquement, mais l'évolution du projet est constante. Cette expérience me permet d'apprendre à gérer un projet web de A à Z dans un contexte professionnel simulé." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Compétences développées" },
                { type: "text", content: "Ce projet enrichissant me permet de développer des compétences techniques (développement web, gestion de projet) et transversales (travail en équipe pluridisciplinaire, communication inter-métiers, respect des deadlines). C'est une expérience concrète qui simule les conditions réelles d'une collaboration en agence ou en entreprise." }
            ]
        }
    ]
};

export default mulligan_site;